import './ccf-wem-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfWemIconProps extends SvgIconProps {}

/**
 * CcfWemIcon used to disply WEM icon in the navigation panel
 * @param props - CcfWemIconProps
 * @example -- <CcfWemIcon />
 */
export function CcfWemIcon(props: CcfWemIconProps) {
  return (
    <SvgIcon {...props}>
     <g id="WEM">
    <g id="Group_120167" data-name="Group 120167" transform="translate(-12 24008)">
      <rect id="Rectangle_80238" data-name="Rectangle 80238" width="44" height="44" rx="2" transform="translate(0 -24020)" opacity="0"/>
      <g id="Group_120168" data-name="Group 120168">
        <path id="Path_24904" data-name="Path 24904" d="M21.331,16H25.32V17.99h-4v-2Z" transform="translate(2.639 -24016.99)"/>
        <path id="Path_25232" data-name="Path 25232" d="M21.331,16H25.32V17.99h-4v-2Z" transform="translate(2.639 -24010.762)"/>
        <path id="Union_3349" data-name="Union 3349" d="M21449.473,13925.5l-1.5,1.5-1-1,1.5-1.5-1.5-1.5,1-1.006.008.016,1.488,1.49,1.488-1.49.016-.016,1,1.006-1.5,1.5,1.5,1.5-1,1Z" transform="translate(-21430.781 -37918.266)"/>
        <path id="Union_3350" data-name="Union 3350" d="M21447.973,13924.993l-1-.99,1-1.006.994,1,2-1.992v-.014l1.006,1-3,3Z" transform="translate(-21430.789 -37924.262)"/>
        <rect id="Rectangle_80879" data-name="Rectangle 80879" width="2" height="4" transform="translate(25 -24008)"/>
        <rect id="Rectangle_80880" data-name="Rectangle 80880" width="2" height="4" transform="translate(17 -24008)"/>
        <path id="Rectangle_80881" data-name="Rectangle 80881" d="M3,2A1,1,0,0,0,2,3V16a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H3M3,0H17a3,3,0,0,1,3,3V16a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z" transform="translate(12 -24007)"/>
      </g>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfWemIcon;
